import { useMemo, useContext } from 'react';

import imageSupportsWebPParam from '@utils/images/imageSupportsWebPParam';
import { WindowContext } from '@providers/WindowProvider';

function useImageSupportsWebP({ src }) {
  const windowObject = useContext(WindowContext);

  const supports = useMemo(
    () => Boolean(windowObject && imageSupportsWebPParam(src)),
    [src, windowObject],
  );

  return supports;
}

export default useImageSupportsWebP;
